import { IAccountOption } from '../venue-provider';

import { DataParent, ExchangeType, IMapDataAccounts } from './portfolio-management.types';

export function updateOrCreateAccountData(
  updatedAccounts: IMapDataAccounts,
  exchangeKey: ExchangeType,
  accountOption: IAccountOption,
  dataParent: DataParent,
  updateData: (dataAccount: any) => void,
  createData: () => any,
): IMapDataAccounts {
  const accountEntry = updatedAccounts[exchangeKey]?.find((acc) => acc.name === accountOption.name);
  if (accountEntry) {
    const dataAccount = accountEntry.dataAccount.find(
      (item: any) => item.dataParent === dataParent,
    );
    if (dataAccount) {
      updateData(dataAccount);
    } else {
      accountEntry.dataAccount.push(createData());
    }
  } else {
    if (!updatedAccounts[exchangeKey]) {
      updatedAccounts[exchangeKey] = [];
    }
    updatedAccounts[exchangeKey].push({
      name: accountOption.name,
      exchange: exchangeKey,
      isCalculated: true,
      dataAccount: [createData()],
    });
  }
  return updatedAccounts;
}
